import { render } from "./stockadjustmentlist.vue?vue&type=template&id=6d381ca0&scoped=true"
import script from "./stockadjustmentlist.vue?vue&type=script&lang=js"
export * from "./stockadjustmentlist.vue?vue&type=script&lang=js"

import "./stockadjustmentlist.vue?vue&type=style&index=0&id=6d381ca0&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d381ca0"]])

export default __exports__